import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  recommendationOptions: [],
  tagUsers: [],
  votingTableData: [],
  prevTableData: [],
  editedRows: [],
  stepperStatus: {
    userFunctionName: '',
    stepperStatus: [],
    userLevel: 0
  },
  saveState: true
};

const feedbackCollationSlice = createSlice({
  name: 'feedbackCollation',
  initialState,
  reducers: {
    setRecommendationOptions: (state, action) => {
      state.recommendationOptions = action.payload;
    },
    setTagUsers: (state, action) => {
      state.tagUsers = action.payload;
    },
    setVotingTableData: (state, action) => {
      state.votingTableData = action.payload;
      state.prevTableData = action.payload;
    },
    setPrevVotingTableData: (state, { payload }) => {
      state.prevTableData = payload;
    },
    handleColumnsChange: (state, action) => {
      let { value, key, id } = action.payload;
      let filteredTable = [...state.votingTableData];
      let filteredEditedRows = [...state.editedRows];
      filteredTable?.map((item) => {
        if (item.CycleSKUKey === id) {
          if (item[key] !== value) {
            filteredEditedRows.push(id);
          }
          item[key] = value;
        }
        return item;
      });
      state.votingTableData = filteredTable;
      state.editedRows = [...new Set(filteredEditedRows)];
      // get current voting
      const stepData = state.stepperStatus['stepperStatus'];
      const taskName = stepData.filter((item) => item.status === 'In Progress')[0]?.taskName;
      // disable button state as per drawer input
      filteredTable?.map((item) => {
        if (filteredEditedRows.includes(item.CycleSKUKey)) {
          if (filteredEditedRows.length > 0) {
            if (taskName === 'Steering Reco') {
              if (item.agreeDisagreeStatus === true) {
                state.saveState = false;
              } else {
                state.saveState = true;
              }
              if (item.agreeDisagreeStatus === false) {
                if (item.recommendation && item.comment) {
                  state.saveState = false;
                }
              }
            } else if (taskName === 'Functional Feedback' || taskName === 'Regional Decisions') {
              if (item.agreeDisagreeStatus === true) {
                state.saveState = false;
              } else {
                state.saveState = true;
              }
              if (item.agreeDisagreeStatus === false) {
                if (item.comment) {
                  state.saveState = false;
                }
              }
            }
          }
        }
        return item;
      });
    },
    setEditedRows: (state, action) => {
      state.editedRows = action.payload;
    },
    setStepperStatus: (state, action) => {
      state.stepperStatus = action.payload;
    },
    setShowSave: (state, action) => {
      state.saveState = action.payload;
    }
  }
});

export const {
  setRecommendationOptions,
  setTagUsers,
  setVotingTableData,
  handleColumnsChange,
  setEditedRows,
  setStepperStatus,
  setPrevVotingTableData,
  setShowSave
} = feedbackCollationSlice.actions;

export default feedbackCollationSlice.reducer;
